// What we can honestly tell a user about where their data came from, derived from the
// run history alone — no extra endpoint.
//
// The connector name isn't in the API yet (the pipeline reads a sample iSmartRecruit
// dataset; live ATS sync is not built). So we name the FORMAT and mark it a sample,
// rather than imply a live connection we don't have.
export const SOURCE = {
  name: 'iSmartRecruit',
  kind: 'Sample dataset',
  liveSyncAvailable: false
};

const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : null);

// lastImport summarizes the most recent successful import from the /runs history.
// /runs already returns ingest runs, newest first, each with its summary stats. Returns
// null when nothing has imported yet.
export function lastImport(runs) {
  const done = (runs || []).find((r) => r.status === 'success');
  if (!done) return null;
  const stats = (done.summary && done.summary.stats) || {};
  return {
    at: done.finished_at || done.completed_at || done.started_at || null,
    durationMs: done.duration_ms ?? null,
    companies: num(stats.companies && stats.companies.total),
    // people are unified by email during ingest, so the meaningful count is `unified`.
    people: num(stats.people && (stats.people.unified ?? stats.people.total)),
    jobs: num(stats.jobs && stats.jobs.total)
  };
}

// recentActivity maps raw runs to a friendlier shape for the activity list: a verb the
// user recognizes, the time, status, and duration. Enrichment runs are pipeline
// 'enrich'/'global'; everything else reads as an import.
export function recentActivity(runs, limit = 8) {
  return (runs || []).slice(0, limit).map((r) => ({
    id: r.run_id,
    action: r.pipeline === 'enrich' || r.pipeline === 'global' ? 'Enriched' : 'Imported',
    at: r.started_at,
    status: r.status,
    durationMs: r.duration_ms ?? null
  }));
}
